module.exports = __webpack_public_path__ + "static/media/logoFrida.baa899eb.png";